module.exports = __webpack_public_path__ + "static/creativity-2084e551640699efc2bc001390bd7826.png";